/* eslint-disable no-underscore-dangle */
/* eslint-disable consistent-return */
/* eslint-disable react/forbid-prop-types */
import MaterialTable from 'material-table';
import React from 'react';
import PropTypes from 'prop-types';
import userServices from '../../../../redux/services/userServices';

const StudentsList = ({
  students, subGroupId, addStudentToGroup, group,
}) => (
  <MaterialTable
    title="Tous"
    data={students}
    style={{
      width: '48%',
      height: '100%',
      zIndex: 0,
    }}
    columns={[
      {
        title: 'Last name',
        field: 'name',
      },
      {
        title: 'First name',
        field: 'firstname',
      },
      {
        title: 'Email',
        field: 'email',
        render: (rowData) => `${rowData.email.slice(0, 16)}${rowData.email.length > 16 ? '..' : ''}`,
      },
    ]}
    options={{
      selection: true,
      pageSize: 10,
    }}
    actions={[
      {
        icon: 'add',
        tooltip: 'Add students to subgroup',
        onClick: (event, rowData) => {
          const res = [];
          rowData.forEach((student) => {
            res.push(student._id);
          });
          userServices.addUsersToSubGroup(group._id, subGroupId, res)
            .then(() => {
              addStudentToGroup(subGroupId, res);
            });
        },
      },
    ]}
  />
);

StudentsList.propTypes = {
  students: PropTypes.array.isRequired,
  group: PropTypes.object.isRequired,
  addStudentToGroup: PropTypes.func.isRequired,
  subGroupId: PropTypes.string.isRequired,
};

export default StudentsList;
